import DeniedTimeOffRequests from './DeniedTimeOffRequests';

export default DeniedTimeOffRequests;
